var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.fail || _vm.failed)?_c('p',[_vm._v("呜呜呜...登陆失败, 再试试吧QAQ")]):_c('p',[_vm._v("登陆中...")]),(_vm.fail || _vm.failed)?_c('login'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }